'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

function firstName() {
    return {
        id: 'firstName',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-firstname',
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.first-name.placeholder'),
        },
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.first-name.required-error'),
            },
            {
                name: 'min-length',
                fn: magicFormBuilder.minLength(2),
                message: magicCommon.translate('sign-up-step-two.first-name.min-length-error'),
            },
            {
                name: 'max-length',
                fn: magicFormBuilder.maxLength(40),
                message: magicCommon.translate('sign-up-step-two.first-name.max-length-error'),
            },
            {
                name: 'contains-letter',
                fn: magicFormBuilder.containsLetter,
                message: magicCommon.translate('sign-up-step-two.first-name.contains-letter-error'),
            },
        ],
        converter: function (formValue) {
            return {
                firstname: formValue.firstName.value,
            };
        },
    };
}

exports.firstName = firstName;
